import { useContext } from 'react';
import { PageContext } from '../context/PageContext.js';

function usePage() {
  return useContext(PageContext);
}

export default usePage;
